import clsx from 'clsx';

import { Header } from 'components/slider/header';
import { Post } from 'components/template/home/posts';

import { IBlogPost } from 'constants/types';
import { usePostsQuery } from 'hooks/api/blog_post';
import { shuffle } from 'lodash';

import styles from './styles.module.css';
import { Routes } from 'constants/routes';
import { useMemo } from 'react';

export const OtherPosts = ({ post }: { post: IBlogPost }) => {
  const { data: { results: posts = [], count = '0' } = {} } = usePostsQuery({
    type: post.type,
  });

  const { url, type } = useMemo(() => {
    switch (post?.type) {
      case 'guide':
        return { url: Routes.guides, type: 'Guides' };
      case 'topic':
        return { url: Routes.news, type: 'News' };
      default:
        return { url: '', type: '' };
    }
  }, [post?.type]);

  let first: IBlogPost | undefined;
  let second: IBlogPost | undefined;

  if (posts && Array.isArray(posts)) {
    [first, second] = shuffle(posts);
  }

  const wrapperPost = clsx(
    styles.row,
    styles.posts__items,
    styles.posts__items_row,
    {
      [styles.wrapper_post]: !second,
    }
  );

  return (
    <section className={clsx(styles.posts, styles.posts_blog)}>
      <div className={styles.container_s}>
        <Header name={`More ${type}`} count={count} url={url} />
        <div className={wrapperPost}>
          <div className={styles.first}>{first && <Post data={first} />}</div>
          <div className={styles.second}>
            {second && <Post data={second} />}
          </div>
        </div>
      </div>
    </section>
  );
};
